
import React, { useState, useRef  } from "react";
import { getAuth, connectAuthEmulator, signInAnonymously } from 'firebase/auth';
import {
  connectStorageEmulator,
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
} from 'firebase/storage';
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {PDFDownloadLink,pdf , Document,Image, Page, Text, View, StyleSheet  } from "@react-pdf/renderer";
import { SiteColor } from "./constants";
import LOGO from './whitelogo.png';
import { useEffect } from "react";
import { Button } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress'; // Loading icon
import { v4 as uuidv4 } from 'uuid'; // Assuming you have the 'uuid' library instal
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBV3wFmPQWCbco8ZQ9D83OeIC2zD2uriuw",
  authDomain: "solar-calc-steelelectrical.firebaseapp.com",
  projectId: "solar-calc-steelelectrical",
  storageBucket: "solar-calc-steelelectrical.appspot.com",
  messagingSenderId: "619710391617",
  appId: "1:619710391617:web:03ec0bfbde5b1e127aadc0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const auth = getAuth();
const storage = getStorage();


// // Locally, we use the firebase emulators.
// if (window.location.hostname === 'localhost') {
//   connectAuthEmulator(auth, 'http://127.0.0.1:9099');
//   connectStorageEmulator(storage, '127.0.0.1', 9199);
// }

const storageRef = ref(storage);
auth.onAuthStateChanged(function (user) {
  if (user) {
    console.log('Anonymous user signed-in.', user);
    
  } else {
    console.log(
      'There was no anonymous session. Creating a new anonymous user.',
    );
    // Sign the user in anonymously since accessing Storage requires the user to be authorized.
    signInAnonymously(auth).catch(function (error) {
      if (error.code === 'auth/operation-not-allowed') {
        window.alert(
          'Anonymous Sign-in failed. Please make sure that you have enabled anonymous ' +
            'sign-in on your Firebase project.',
        );
      }
    });
  }
});



const Item = ({ item }) => (

  <View style={styles.item}>
        <Text style={{width: '50%', textAlign : 'left'}}> {item.primary}</Text>
        <Text style={{width: '12%'}}> {item.quantity}</Text>
        <Text style={{width: '12%'}}> {item.runningWatts}</Text>
        <Text style={{width: '12%'}}> {item.hoursPerDay}</Text>
        <Text style={{width: '12%'}}> { ((item.runningWatts * item.quantity * item.hoursPerDay) / 1000).toFixed(2)}</Text>
  </View>
);

const pageSize = 10;


const ReportDocument = ({
  potentialLoadKW,
  averageKWhPerDay,
  usePercent,
  daysOfReservePower,
  winterAvgDailyEffectiveSolar,
  requireThreePhase,
  solarArraySize,
  batteryStorageSize,
  inverterSize,
  pages,
  firstName,
  lastName,
  email,
  phone,
  address,
  company
}) => {



  return (

    <Document>
    <Page key="main" size="A4" style={styles.page}>
    <View style={styles.header}>
      <Image src={LOGO} style={styles.logo} />
    </View>
    <View style={styles.section}>
        <Text style={{     marginLeft: 50,marginRight: 50, marginTop: 15, marginBottom: 15}} >{`Hi ${firstName}, \n  \n We've calculated your solar installation requirements based on the appliances you've selected. To discuss any further customisations, please email office@steelelectrical.co.nz or give us a call on 0508 2 SOLAR (0508 276 527).`}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText} >Potential load KW</Text>
        <Text style={styles.itemText}>{potentialLoadKW}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Average KWh per day</Text>
        <Text>{averageKWhPerDay}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Percentage of appliances used at the same time</Text>
        <Text>{`${usePercent}%`}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Days of reserve power</Text>
        <Text>{daysOfReservePower}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Winter average daily effective solar</Text>
        <Text>{winterAvgDailyEffectiveSolar}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Require three phase</Text>
        <Text>{`${requireThreePhase ? 'yes' : 'no'}`}</Text>  
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Solar array size</Text>
        <Text>{solarArraySize}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Battery storage size</Text>
        <Text>{batteryStorageSize}</Text> 
      </View>
      <View style={styles.section}>
        <Text style={styles.titleText}>Inverter size</Text>
        <Text>{inverterSize}</Text>
      </View>

      <View style={{ marginLeft: 50,marginRight: 50,  backgroundColor:'lightgray'}}> 
        <View style={styles.section}>
          <Text  >Prepared for:</Text>
        </View>
        <View style={styles.section}>
          <View style={{width: '50%'}}><Text >{`First name : ${firstName??''}`}</Text></View>
          <View style={{width: '50%'}}><Text >{`Last name : ${lastName??''}`}</Text></View>
          </View>   

          <View style={styles.section}>
          <View style={{width: '50%'}}><Text >{`Email : ${email??''}`}</Text></View>
          <View style={{width: '50%'}}><Text >{`Phone : ${phone??''}`}</Text></View>
          </View>   

          <View style={styles.section}>
          <View style={{width: '50%'}}>  <Text >{`Address : ${address??''}`}</Text></View>
          <View style={{width: '50%'}}><Text >{`Company : ${company??''}`}</Text></View>  
          </View>   
      </View>
    </Page>

    {pages.map((pageItems, pageIndex) => (
    <Page key={pageIndex} size="A4" style={styles.page}>
    <View style={styles.section}>
        <Text style={{     marginLeft: 50,marginRight: 50, marginTop: 50, marginBottom: 15}} >{ pageIndex === 0 ? 'These are the appliances you selected.' : 'continued...'}</Text>
      </View>

    <View style={styles.itemHeader}>
        <Text style={{...styles.itemText, textAlign : 'left',  width : '50%'}} >Name</Text>
        <Text style={{...styles.itemText, fontSize : 8 , width : '12%'}} >Quantity</Text>
        <Text style={{...styles.itemText, fontSize : 8 , width : '12%'}} >Running Watts</Text>
        <Text style={{...styles.itemText, fontSize : 8 , width : '12%'}} >Hours Per Day</Text>
        <Text style={{...styles.itemText, fontSize : 8 , width : '12%'}} >KWH Per Day</Text>
      </View>
      <View style={styles.listContainer}>
        {pageItems.map((item) => (
          <Item key={item.id} item={item} />
        ))}
      </View>

      </Page>
  ))}



  </Document> 
  );
};


const ReportViewer = ({
  potentialLoadKW,
  averageKWhPerDay,
  usePercent,
  daysOfReservePower,
  winterAvgDailyEffectiveSolar,
  requireThreePhase,
  solarArraySize,
  batteryStorageSize,
  inverterSize,
  items,
  firstName,
  lastName,
  email,
  phone,
  address,
  company
}) => {

  const [loading, setLoading] = useState(false);
  const firebaseStoragepath = useRef(null);
  const reportid = useRef(uuidv4());
  const [pages, setPages] = useState([]);

  useEffect(() => {
        const pageSize = 30;
        const pages = [...Array(Math.ceil(items.length / pageSize))].map((_, i) =>
          items.slice(i * pageSize, (i + 1) * pageSize)
        );

        setPages(pages);
  }, [items]);
 
  const handleDownloadClick = async (report) => {

    setLoading(true);

    const blob = await pdf(report).toBlob();
    let url  = null;
    if (blob) {
      try {
          // Push to child path.
          const snapshot = await uploadBytes(ref(storageRef, `reports/steelelectrical_${reportid.current}.pdf`), blob);
           url = await getDownloadURL(snapshot.ref);
          firebaseStoragepath.current = url;
      } catch (error) {
        console.error('Upload failed:', error);
        firebaseStoragepath.current = null;
      }
      
    }

    if (url) {
      const link = document.createElement('a');
      link.href = url;
      //link.target = '_blank'; // Open in new tab
      // Remove the line setting the 'download' attribute
      link.setAttribute('download', 'steelelectrical-solar-report.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } else {
      console.error('Download URL not available yet.');
      // Potentially display an error message to the user
    }

    setLoading(false);
  };

  
  
  return (
    
<div style={{width:'100%'}}>
  
    <Button onClick={() => handleDownloadClick(
    <ReportDocument
      potentialLoadKW={potentialLoadKW}
      averageKWhPerDay={averageKWhPerDay}
      usePercent={usePercent}
      daysOfReservePower={daysOfReservePower}
      winterAvgDailyEffectiveSolar={winterAvgDailyEffectiveSolar}
      requireThreePhase={requireThreePhase}
      solarArraySize={solarArraySize}
      batteryStorageSize={batteryStorageSize}
      inverterSize={inverterSize}
      firstName={firstName}
      lastName={lastName}
      email={email}
      phone={phone}
      address={address}
      company={company}
      pages={pages}
    />)}  style={styles.button}> {loading ? (
      <CircularProgress size={24} />
    ) : (
      'View REPORT'
    )}</Button>
</div>
      
  
          );};




  const styles = StyleSheet.create({
    page: {
      // Page-level 
      alignContent: 'center',
      fontSize: 12,
    },
      // ... other styles
      logo: {
        backgroundColor: 'black',
        width: 600, // Adjust as needed
      },
      header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between', // Example 
        marginBottom: 10,
      },
    
    section: {
      // Styles for sections or 
      flexDirection: 'row',
      textAlign: 'left',
      alignItems: 'baseline',
      justifyContent: 'flex-start',
      alignContent: 'flex-start',
      padding:10,
    },
    titleText: {
      // Styles for sections or 
      width :'75%',
      marginLeft: 50,
      marginRight: 5,
    },
    listContainer: {
    },
    itemHeader: {
      fontSize: 12,
      // Styles for sections or 
      flexDirection: 'row',
      textAlign: 'center',
      alignItems: 'baseline',
      justifyContent: 'space-evenly',
      alignContent: 'space-around',
      padding:10,
      marginLeft: 50,
      marginRight: 50,
    },
    item: {
      fontSize: 12,
      // Styles for sections or 
      flexDirection: 'row',
      textAlign: 'center',
      alignItems: 'baseline',
      justifyContent: 'space-evenly',
      padding:5,
      marginLeft: 50,
      marginRight: 50,
    },
    itemText: {
      textAlign: 'right',
    },  
    button: {
      fontSize: 20,
      width: '100%', /* Full width */
      border: '1px solid #ccc', 
      borderRadius: 4, /* Add a grey border */  
      backgroundColor: SiteColor, /* Green background */
      color: '#fff', /* White text */
      padding: 10, /* Add padding for spacing */

      textDecoration: 'none', /* Remove default link underline */
    },
  });

  export default ReportViewer;